'use strict';

(function () {
    'use strict';

    angular.module('app.admin', ['app.services', 'nemLogging', 'ui-leaflet', 'ui.select', 'nvd3', 'dds.ago']);
})();